"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileSubmitCircleIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var FileSubmitCircle = function FileSubmitCircle(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M7.77 14.34a.33.33 0 00-.33 0 .31.31 0 00-.18.28v.47a.16.16 0 01-.16.15H5.39a.63.63 0 100 1.25H7.1a.16.16 0 01.16.16v.47a.31.31 0 00.51.24l1.56-1.25a.32.32 0 00.11-.24.33.33 0 00-.11-.25z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M12 0a12 12 0 1012 12A12 12 0 0012 0zM7.26 19.9a4.06 4.06 0 114.06-4.06 4.06 4.06 0 01-4.06 4.06zm2.81-10.31a.62.62 0 01.62-.59h4.38a.63.63 0 010 1.25h-4.38a.63.63 0 01-.62-.66zM11.34 13a5 5 0 00-.75-.84.09.09 0 010-.08.11.11 0 010-.08.58.58 0 01.43-.18h2.5a.63.63 0 010 1.25h-2a.17.17 0 01-.18-.07zm6.85 3.5a1.25 1.25 0 01-1.25 1.25h-4.83a.16.16 0 01-.13-.06.2.2 0 010-.15 4.65 4.65 0 00.22-.91.17.17 0 01.16-.13h4.28a.31.31 0 00.31-.31v-8.4a.31.31 0 00-.09-.22l-1.34-1.32a.28.28 0 00-.22-.09H8.51a.31.31 0 00-.31.31v4.28a.17.17 0 010 .12.19.19 0 01-.12 0c-.28 0-.7-.05-.93-.05A.16.16 0 017 10.7V6.16a1.25 1.25 0 011.2-1.25h7.23a1.29 1.29 0 01.89.36l1.5 1.51a1.23 1.23 0 01.37.88z"
  }));
};
FileSubmitCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const FileSubmitCircleIcon = exports.FileSubmitCircleIcon = (0, _createIconComponent.default)(FileSubmitCircle, 'FileSubmitCircle');